<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">微信号列表</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="newAddperson()">新增微信个人号</el-button>
            <el-button style="float: right;margin-left:10px;" type="success" @click="newAddwx()">新增微信公众号</el-button>
            <el-button style="float: right;margin-left:10px;" type="danger" @click="removeWxResourse()">删除微信号</el-button>
            <!-- <el-button style="float: left;margin-left:10px;" type="danger" @click="removePersonResourse()">删除微信个人号</el-button> -->
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column 
                    type="selection" 
                    header-align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="code"
                    header-align="center"
                    width="68"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop="name"
                    header-align="center"
                    min-width="120"
                    label="名称">
                </el-table-column>
                <el-table-column
                    prop="description"
                    header-align="center"
                    min-width="155"
                    label="描述">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    width="110"
                    label="配置说明">
                    <template scope="scope">
                        <span href="#" v-if="scope.row.pType==0" @click="addConfig(scope.row)" style="color:#337ab7;cursor:pointer;">公众号配置</span>
                        <span href="#" v-else @click="toAuthPerson(scope.row.url, scope.row.appId)" style="color:#337ab7;cursor:pointer;">个人号授权</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="appId"
                    header-align="center"
                    min-width="125"
                    label="公众号ID">
                </el-table-column>
                <el-table-column
                    prop="status"
                    header-align="center"
                    min-width="115"
                    label="状态">
                </el-table-column>
                <el-table-column
                    prop="logo"
                    header-align="center"
                    min-width="5"
                    label="LOGO" v-if="false">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="280"
                    label="LOGO">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="left-start"
                          trigger="hover">
                          <img  :src="scope.row.logo" style="width:140px;"/>
                        </el-popover>
                      <a v-popover:popoverPayStatus1 :href="scope.row.logo" target="_blank">{{scope.row.logo}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="qrcode"
                    header-align="center"
                    min-width="5"
                    label="二维码" v-if="false">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="280"
                    label="二维码">
                    <template scope="scope">
                        <el-popover
                          ref="popoverPayStatus1"
                          placement="right-start"
                          trigger="hover">
                          <img  :src="scope.row.qrcode" style="width:140px;"/>
                        </el-popover>
                        <a v-popover:popoverPayStatus1 :href="scope.row.qrcode" target="_blank">{{scope.row.qrcode}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="article"
                    header-align="center"
                    min-width=""
                    label="入口文章(说明)" v-if="false">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="240"
                    label="入口文章(说明)">
                    <template scope="scope">
                        <a :href="scope.row.article" target="_blank">{{scope.row.article}}</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
      <pu-add-wxconfig :add-show="addConfigShow" :my-appid="myAppid" @closeAddAccount="closeAddAccountBox"></pu-add-wxconfig>
      <person-auth :add-show="personConfigShow" :url="url" :my-appid="myAppid" @closeAddAccount="closePersonAuth"></person-auth>
      <pu-add-wx-resourse :add-show="addWxRsShow" @closeAddAccount="closeWxRsBox"></pu-add-wx-resourse>
      <pu-add-person-resourse :add-show="addPersonShow" @closeAddAccount="closePersonBox"></pu-add-person-resourse>
    </div>
</template>

<script>
import $axios from '../../https/config'
import popConfig from '@/page/adMgr/addConfig'
import personAuth from '@/page/adMgr/personAuth'
import popWxResourse from '@/page/adMgr/addWxResourse'
import popPersonResourse from '@/page/adMgr/popPersonResourse'
export default {
  data () {
    return {
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0,
      multipleSelection: [],
      addConfigShow: false,
      personConfigShow: false,
      addWxRsShow: false,
      myAppid: '',
      url: '',
      addPersonShow: false
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList()
  },
  methods: {
    newAddperson () {
      this.addPersonShow = true
    },
    queryDeviceList () {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/device/getWeixinList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var mType = '---'
              console.log('--------'+itemData.status)
                  if (itemData.status === '0') {
                    mType = '正常'
                  } else if (itemData.status === '1') {
                    mType = '删除'
                  } else if (itemData.status === '2') {
                    mType = '等待授权'
                  } else if (itemData.status === '3') {
                    mType = '已下线'
                  }
              
              var item = {
                code: itemData.id,
                name: itemData.name,
                description: itemData.description,
                appId: itemData.appid,
                status: mType,
                logo: itemData.wx_logo,
                qrcode: itemData.qrcode,
                pType: itemData.pType,
                article: itemData.wxArticleUrl,
                url: itemData.url
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList()
    },
    addConfig (row) {
      this.myAppid = row.appId
      this.addConfigShow = true
    },
    newAddwx () {
      this.addWxRsShow = true
    },
    toAuthPerson (url, appid) {
      this.personConfigShow = true
      this.myAppid = appid
      this.url = url
      // window.open(url, '_blank')
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList()
    },
    handleSelectionChange (selection) {
      this.multipleSelection = ''
      for (var i = 0; i < selection.length; i++) {
        this.multipleSelection += (selection[i].code + '|')
      }
    },
    closeAddAccountBox (v) {
      this.addConfigShow = false
      // this.pageNo = 1
      this.queryDeviceList()
    },
    closePersonAuth () {
      this.personConfigShow = false
      this.queryDeviceList()
    },
    closeWxRsBox (v) {
      this.addWxRsShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    closePersonBox () {
      this.addPersonShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    removeWxResourse () {
      var that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: '请选择要回收的资源',
          type: 'info'
        })
        return false
      }
      var params = {
        wxIds: that.multipleSelection
      }
      that.$confirm('您已选择广告的ID：' + that.multipleSelection, '是否删除选中的视频', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/device/delWxResources', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.queryDeviceList()
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'pu-add-wxconfig': popConfig,
    'pu-add-wx-resourse': popWxResourse,
    'pu-add-person-resourse': popPersonResourse,
    'person-auth': personAuth
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    a {
      color:#337ab7;
      text-decoration:none;
    }
</style>


// WEBPACK FOOTER //
// src/page/adMgr/adWeixin.vue